import { Vue, Component, Prop, Watch } from "@wagich/vue-facing-decorator-metadata";
import { format, fromUnixTime, getMonth, getYear, getDayOfYear } from "date-fns";
import { de as deLocale } from "date-fns/locale";
import queryString from "query-string";

import { render } from "./course-result-card.html";
import { type SearchResultItem } from "../models/search-result-item";
import { FavoriteToggle } from '../favorites/favorite-toggle';
import { extractValueFromDisplayName, getLocationNames } from '../utilities';

@Component({
	render,
	components: {
		FavoriteToggle
	}
})
export class CourseResultCard extends Vue {
	@Prop({ required: true })
	value: SearchResultItem;

	@Prop({ default: false })
	showDate: boolean;

	@Prop({ required: false })
	queryId: string | null;

	get imageAspectRatio(): number {
		const nameLength = this.value.name.length;
		const moduleNameLength = this.value.moduleName ? this.value.moduleName.length : 0;
		return 1.75 + ((nameLength * 2 + moduleNameLength) * 0.0035);
	}

	get hasLongName(): boolean {
		return this.value.name.length > 100;
	}

	get descriptionSnippetHtml(): string {
		if (this.value._snippetResult && this.value._snippetResult.description) {
			return this.value._snippetResult.description.value.replace(" …", " …"); // replace space before ellipsis with non-breaking space
		} else {
			return this.value.description;
		}
	}

	get imageUrl() {
		if (this.value.imageUrl == null) {
			return "";
		}
		var parsed = queryString.parseUrl(this.value.imageUrl);
		parsed.query.width = "500";
		parsed.query.height = "300";
		return queryString.stringifyUrl(parsed);
	}

	get date(): string {
		if (this.value.beginTimestamp == null || this.value.endTimestamp == null) {
			return "";
		}
		var begin = fromUnixTime(this.value.beginTimestamp);
		var end = fromUnixTime(this.value.endTimestamp);

		if (getDayOfYear(begin) === getDayOfYear(end)) {
			return format(begin, "D. MMMM yyyy", { locale: deLocale });
		}
		else if (getYear(begin) === getYear(end)) {
			if (getMonth(begin) === getMonth(end)) {
				return `${format(begin, "d.", { locale: deLocale })}–${format(end, "d. MMMM yyyy", { locale: deLocale })}`;
			}
			else {
				return `${format(begin, "d. MMM", { locale: deLocale })}–${format(end, "d. MMM yyyy", { locale: deLocale })}`;
			}
		} else {
			return `${format(begin, "d.MM.yyyy", { locale: deLocale })}–${format(end, "d.MM.yyyy", { locale: deLocale })}`;
		}
	}

	get locationName(): string {
		return extractValueFromDisplayName(this.value.location?.displayName);
	}

	get locationNames(): string {
		return getLocationNames(this.value);
	}

	open() {
		this.$emit("clicked", this.value.objectID);
		location.href = this.value.url;
	}
}
